<script>
import { camelToTitleCase } from "@bloglovin/vue-framework";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import BrandedTextOptions from "%/dynamic-component-editor/bundles/branded-text-options";
import BrandedTextElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedTextElement.vue";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import LinkToEntityPage from "%/dynamic-component-editor/options/link-to-entity-page";
import Prefix from "%/dynamic-component-editor/options/prefix";
import Suffix from "%/dynamic-component-editor/options/suffix";
import NumberFormat from "%/dynamic-component-editor/options/number-format";
import { formatFieldText } from "%/dynamic-components/render-engine/helpers/number-format";
import { resolveEntityPageUrl }
  from "@bloglovin/inspire-engine/DynamicComponents/Helpers/entity-page-links";

export default {
  name: "DynamicAppTextElement",
  // Branded extends so a bound app field styles like a Heading/Paragraph;
  // only the free-text "Text" row is hidden (text comes from the field).
  extends: BrandedTextElement,
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "text",
    elementType: "element",
  },
  hidden: true,
  optionBundles: [
    new BrandedTextOptions({
      "default.text-style-option": "paragraph",
    }, {
      "text-option": true,
    }),
  ],
  options: [
    LinkToEntityPage,
    Prefix,
    Suffix,
    NumberFormat,
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      if (!this.editMode && this.isPreviewMode && !this.valueFromContext) {
        return this.placeholderText;
      }
      return formatFieldText(this.valueFromContext, {
        format: this.getOptionValue(NumberFormat),
        prefix: this.getOptionValue(Prefix),
        suffix: this.getOptionValue(Suffix),
      });
    },
    // "Link To Page": resolve the bound entity's display page through the
    // host-registered resolver; the text-element-mixin click machinery
    // (actionType / hasClickValue / clickValue) prefers this href, so a
    // linked Story/Event title navigates like an authored goToUrl click
    // action. Edit mode never links (canvas clicks select the element);
    // a null resolution renders unlinked.
    entityPageHref() {
      if (this.editMode || this.isPreviewMode || !this.contextItem
        || this.getOptionValue(LinkToEntityPage) !== true) {
        return null;
      }
      return resolveEntityPageUrl(
        this.entityType,
        this.contextItem.entityPkUrlVars,
        this.contextAppName,
      );
    },
    // Edit-mode placeholder: prefer the bound field's exampleData, else a
    // title-cased field label, so the canvas reads like the app's design.
    placeholderText() {
      if (this.editMode || this.isPreviewMode) {
        if (this.exampleData) {
          return this.exampleData;
        }
        const field = this.elementContext?.field;
        if (field) {
          return camelToTitleCase(field);
        }
      }
      return this.$options.elementPanelSettings?.displayName || "Add text";
    },
  },
};
</script>
